import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { logDev } from "@/lib/log";

export const CONSENT_KEY = "faro_cookie_consent";

export const getCookieConsent = () => {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
};

export const CookieBanner = () => {
  const [choice, setChoice] = useState(() => getCookieConsent());

  const decide = (value) => {
    try {
      localStorage.setItem(CONSENT_KEY, value);
    } catch (err) {
      logDev("No se pudo guardar la preferencia de cookies:", err);
    }
    setChoice(value);
    if (value === "accepted") window.dispatchEvent(new Event("faro-consent-accepted"));
  };

  if (choice) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[90] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto rounded-2xl bg-[var(--faro-blue-deep)] text-white shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex items-start gap-3 flex-1">
          <Cookie size={20} className="text-[var(--faro-yellow)] shrink-0 mt-0.5" />
          <p className="text-sm text-white/85 leading-snug">
            Usamos cookies analíticas (Google Analytics) para mejorar la web. Solo se activan si las aceptas.{" "}
            <Link to="/politica-cookies" className="underline underline-offset-2 font-bold text-white">Más información</Link>
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <button onClick={() => decide("rejected")} data-testid="cookie-reject" className="btn-pill bg-white/10 hover:bg-white/20 text-white text-sm">
            Rechazar
          </button>
          <button onClick={() => decide("accepted")} data-testid="cookie-accept" className="btn-pill btn-primary text-sm">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};
